module.exports = __webpack_public_path__ + "img/face-smile-tear.f2cd550b.svg";